import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

class ResultsFilterWidget extends ReactiveWidget  {
  bind() {
    this.form = this.root.find('form')
    this.form.find('.loading-spinner').hide()
    this.freshData = freshData
    stopSpinner.call(this)
    bindFormActions.call(this)

    // Fetch the data
    resetPage.call(this)
    fetchData.call(this)
  }

  render() {
  }
}

var freshData = function() {
  fetchData.call(this)
}

var bindFormActions = function() {
  this.root.on('keyup', this.form.find('input'), (e) => {
    delay(() => {
      resetPage.call(this)
      fetchData.call(this)
    }, 300 );
  })

  // Select 2
  let select2_elem = this.form.find(".filter-select2")
  $(select2_elem).select2({
    placeholder: 'Select',
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    resetPage.call(this)
    fetchData.call(this)
  })

  // Pagination
  // let pagination_links = this.root.find('.pagination a')/
  this.root.on('click', '.pagination a', (e) => {
    e.preventDefault()
    e.stopPropagation()

    let url   = $(e.target).attr('href')
    this.form.find("input[name='page']").val(window.getSearchParams(url, 'page') || "0")
    fetchData.call(this)
  })

  // Capture Form Submit
  this.form.on('submit', (e) => {
    e.preventDefault();
    fetchData.call(this)
    return false
  })
}

var fetchData = function() {
  $.ajax({
    url: this.form.attr('action'),
    dataType: 'json',
    data: this.form.serializeArray(),
    beforeSend: (e) => {
      startSpinner.call(this)
    },
    success: (response) => {
      this.renderPartial(this.root.find('.data-results'), response.results_partial)
      stopSpinner.call(this)
    },
    error: (xhr, text, error) => {
      swal({
        type: 'error',
        title: xhr.statusText
      })
      stopSpinner.call(this)
    }
  });
}

var resetPage = function() {
  this.form.find("input[name='page']").val('0')
}

var startSpinner = function() {
  this.form.find('.loading-spinner').fadeIn(400)
}

var stopSpinner = function() {
  this.form.find('.loading-spinner').fadeOut(400)
}

export default ResultsFilterWidget
